export default __webpack_public_path__ + "_/videos/lootbox/video-csgo-9454af8db01daa5ce480ae7ee57fdf57b9970606fe5745058b6c9afc4b14c202.mp4";